import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router';
import { getStaffAnalyticsUpdateRequestBoundsQueryOptions } from '~/hooks/queries/useStaffAnalyticsUpdateRequestBoundsQuery';
import { staffAdminPermsLoader } from './staffAdminPermsLoader';

/** Staff ops admin gate, then prefetch analytics update bounds. */
export function prefetchStaffAnalyticsUpdateRequestLoader(queryClient: QueryClient) {
  const ensureStaffAdmin = staffAdminPermsLoader(queryClient);

  return async (args: LoaderFunctionArgs) => {
    await ensureStaffAdmin(args);
    queryClient.prefetchQuery(getStaffAnalyticsUpdateRequestBoundsQueryOptions());
    return null;
  };
}
